import React, { useEffect, useRef, useState } from "react";
import "./EditarMotivoDefeitoModal.css";

const sanitizeMotivoInput = (value, max = 120) =>
  String(value ?? "")
    .replace(/[\u0000-\u001F\u007F]/g, "")
    .replace(/[<>]/g, "")
    .toUpperCase()
    .slice(0, max);

const sanitizeMotivoSave = (value, max = 120) => sanitizeMotivoInput(value, max).trim();

export default function EditarMotivoDefeitoModal({ open, onClose, onSalvar, motivoInicial = "" }) {
  const [motivo, setMotivo] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const motivoRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setMotivo(sanitizeMotivoInput(motivoInicial));
    setBusy(false);
    setErr("");

    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => motivoRef.current?.focus(), 0);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = prev;
    };
  }, [open, motivoInicial]);

  if (!open) return null;

  async function handleSalvar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      const normalized = sanitizeMotivoSave(motivo);
      if (!normalized) throw new Error("Informe o motivo do defeito.");
      await onSalvar?.(normalized);
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao salvar alteracoes.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ptemd-overlay" onClick={onClose}>
      <div className="ptemd-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Editar motivo do defeito">
        <div className="ptemd-head">
          <h3 className="ptemd-title">Editar Motivo do Defeito</h3>
          <button className="ptemd-close" type="button" onClick={onClose} disabled={busy} aria-label="Fechar">
            x
          </button>
        </div>

        <div className="ptemd-body">
          <label className="ptemd-field">
            <span>Motivo do defeito</span>
            <input
              ref={motivoRef}
              type="text"
              value={motivo}
              onChange={(event) => setMotivo(sanitizeMotivoInput(event.target.value))}
              placeholder="Ex: CORROSAO NA PATA"
              autoComplete="off"
            />
          </label>
          {err ? <div className="ptemd-error">{err}</div> : null}
        </div>

        <div className="ptemd-foot">
          <button className="ptemd-btn ptemd-btn-ghost" type="button" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button className="ptemd-btn ptemd-btn-primary" type="button" onClick={handleSalvar} disabled={busy}>
            {busy ? "Salvando..." : "Salvar alteracoes"}
          </button>
        </div>
      </div>
    </div>
  );
}
